import { SendMoney } from './pages/SendMoney';

export default SendMoney;
